const getArrayOfIds = (list: any[], property: String) => {
  const listOfIds = []

  list.map((item: any, index) => {
    // @ts-ignore
    listOfIds.push(item[property])
    return false
  })

  return listOfIds
}

export default getArrayOfIds
